// extracted by mini-css-extract-plugin
module.exports = {"row":"privacyPolicy-module--row--3wQZq","content":"privacyPolicy-module--content--3poDi","p":"privacyPolicy-module--p--26csY"};